import { render, staticRenderFns } from "./TvRemoteControllerSlim1.vue?vue&type=template&id=3fbdd283"
import script from "./TvRemoteControllerSlim1.vue?vue&type=script&lang=js"
export * from "./TvRemoteControllerSlim1.vue?vue&type=script&lang=js"
import style0 from "./TvRemoteControllerSlim1.vue?vue&type=style&index=0&id=3fbdd283&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports